import { render, staticRenderFns } from "./Gvd.vue?vue&type=template&id=8f5b021c&scoped=true"
import script from "./Gvd.vue?vue&type=script&lang=ts"
export * from "./Gvd.vue?vue&type=script&lang=ts"
import style0 from "./Gvd.vue?vue&type=style&index=0&id=8f5b021c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5b021c",
  null
  
)

export default component.exports